import { Pipe, PipeTransform } from '@angular/core';
import {DataEntity} from "octopus-connect";

@Pipe({
  name: 'filterEducationalLevelsPipe',
  standalone: true
})
export class FilterEducationalLevelsPipe implements PipeTransform {

    transform(allLevels: DataEntity[], levelsSelected:  DataEntity[]): DataEntity[] {
        if (!allLevels || !levelsSelected) return allLevels || [];
        // On suppose que selectedLevels est un tableau d'IDs
        const selectedIds = levelsSelected.map(lvl => lvl.id);
        return allLevels.filter(level => selectedIds.includes(level.id));
    }

}
